import React from 'react';
import styles from './Footer.module.scss';
import companyLogo from '@assets/logo-just-eat-takeaway-corporate-logo-orange-rgb.svg';
import { Trans, useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
export const Footer = () => {
  useTranslation();
  return (
    <footer className={`${styles.footerSection} footer_section`}>
      <img src={companyLogo} className={styles.companyLogo} alt="Just Eat Takeaway.com" />
      <div className={styles.legalLinks}>
        <ul className={styles.legalLinksWrapper}>
          <li>
            <NavLink to={'/impressum'}>
              <Trans i18nKey="footer.footer_url_impressum" />
            </NavLink>
          </li>
          <li>
            <NavLink to={'/terms-of-use'}>
              <Trans i18nKey="footer.footer_url_legal_terms" />
            </NavLink>
          </li>
          <li>
            <NavLink to={'/privacy'}>
              <Trans i18nKey="footer.footer_url_privacy_state" />
            </NavLink>
          </li>
          <li>
            <NavLink to={'/cookie-statement'}>
              <Trans i18nKey="footer.footer_url_cookie_state" />
            </NavLink>
          </li>
        </ul>
        <div className={`${styles.copyright} copyright_section`}>
          &copy; {new Date().getFullYear()} Takeaway.com
        </div>
      </div>
    </footer>
  );
};

export default Footer;
